module.exports = __webpack_public_path__ + "img/sc-award-title.38d4e887.png";